



















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import FeriadoModel from "@/models/cadastros/saude/FeriadoModel";
import { feriadoService } from "@/service/cadastro/saude/feriado/FeriadoService";
import { saudeCidadeService } from "@/service/cadastro/saude/cidade/SaudeCidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList } from "@/models/commons/EstadoModel";
import { tiposFeriadosList } from "@/models/cadastros/saude/TipoFeriadoModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
  },
})
export default class CadastroFeriado extends Vue {
  $refs!: {
    feriadoObserver: InstanceType<typeof ValidationObserver>;
  };

  feriado: FeriadoModel = {
    cidade: undefined,
    dataFeriado: undefined,
    descricao: undefined,
    estado: undefined,
    tipo: undefined,
  };

  estados = estadosList;
  cidades: [] = [];
  tiposFeriado = tiposFeriadosList;

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  dialogKey = 0;
  dialog = false;

  mounted() {
    this.loadInfo();
  }

  obterCidades() {
    if(!!this.feriado?.estado?.sigla) {
      saudeCidadeService
      .obterCidadesPorEstado(this.feriado?.estado?.sigla)
      .then((res) => {
        this.cidades = res;
      });
    }
  }

  acaoDialog(tipo: string) {
    if (tipo == "sucesso") {
      this.$router.push({ name: "ListaFeriados" });
    } else {
      this.openDialog = false;
    }
  }

  gravar() {
    this.$refs.feriadoObserver.validate().then((valid) => {
      if (valid) {
        if (this.$route.params.idFeriado) {
          feriadoService
            .atualizar(this.feriado, new Number(this.$route.params.idFeriado))
            .then((res: any) => {
              this.dialogTitle = "Alteração realizada com sucesso";
              this.dialogMessage = "Alteração realizada com sucesso";
              this.dialogStyle = "success";
              this.dialogType = "sucesso";
              this.openDialog = true;
            })
            .catch((err: any) => {
              this.dialogTitle = "Erro";
              this.dialogMessage = err.message;
              this.dialogStyle = "error";
              this.dialogType = "";
              this.openDialog = true;
            });
        } else {
          feriadoService
            .salvar(this.feriado)
            .then((res) => {
              this.dialogTitle = "Cadastro realizado com sucesso";
              this.dialogMessage = "Cadastro realizado com sucesso";
              this.dialogStyle = "success";
              this.dialogType = "sucesso";
              this.openDialog = true;
            })
            .catch((err) => {
              this.dialogTitle = "Erro";
              this.dialogMessage = err.message;
              this.dialogStyle = "error";
              this.dialogType = "";
              this.openDialog = true;
            });
        }
      }
    });
  }

  loadInfo() {
    if (this.$route.params.idFeriado) {
      feriadoService
        .obterFeriadoPorId(new Number(this.$route.params.idFeriado))
        .then((res) => {
          this.feriado = {
            cidade: res.cidade,
            dataFeriado: res.dataFeriado,
            descricao: res.descricao,
            tipo: this.tiposFeriado.find((tipo) => tipo.name == res.tipo),
          };
          if (res.tipo == "ESTADUAL") {
            this.feriado.estado = this.estados.find((estado) => estado.sigla == res.estado)
          } else if (res.tipo == "MUNICIPAL") {
            this.feriado.estado = this.estados.find((estado) => estado.sigla == res.cidade.estado)
          }
          this.obterCidades();
        });
    }
  }

  get isMunicipal() {
    return this.feriado.tipo?.name == "MUNICIPAL";
  }

  get isEstadual() {
    return this.feriado.tipo?.name == "ESTADUAL";
  }
}
